// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Estrella de favoritos de la barra superior.
 *
 * El botón reutiliza \`.navbar-action-btn\` (mismo alto y tipografía que
 * Tutoriales/Avisos); aquí solo van el estado activo y el desplegable de ámbito.
 */

.navbar-fav {
  position: relative;
  display: flex;
  align-items: center;
}

.navbar-fav-btn.is-favorite {
  color: #f5b301;
}

.navbar-fav-btn.is-favorite .navbar-fav-icon {
  fill: #f5b301;
  stroke: #f5b301;
}

.navbar-fav-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  stroke-width: 1.7;
}

.navbar-fav-popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1200;
  min-width: 260px;
  padding: 6px;
  background: var(--bg-card, #fff);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 10px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);
}

.navbar-fav-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 10px 10px;
  border-bottom: 1px solid var(--border, #e2e8f0);
  margin-bottom: 4px;
}

.navbar-fav-head-title {
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--text-primary, #0f172a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navbar-fav-head-sub {
  font-size: 0.72rem;
  color: var(--text-muted, #64748b);
}

.navbar-fav-option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 10px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: var(--text-primary, #0f172a);
  font-family: inherit;
  font-size: 0.82rem;
  text-align: left;
  cursor: pointer;
}

.navbar-fav-option:hover {
  background: rgba(var(--accent-rgb, 59, 130, 246), 0.12);
}

.navbar-fav-option.is-danger {
  color: #dc2626;
}

.navbar-fav-option.is-danger:hover {
  background: rgba(220, 38, 38, 0.1);
}

.navbar-fav-foot {
  padding: 8px 10px 4px;
  margin-top: 4px;
  border-top: 1px solid var(--border, #e2e8f0);
  font-size: 0.7rem;
  line-height: 1.35;
  color: var(--text-muted, #64748b);
}

@media (max-width: 1200px) {
  /* En pantallas estrechas el navbar ya va justo: la estrella se queda sola. */
  .navbar-fav-btn .action-label {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FavoriteButton.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,4CAA4C;EAC5C,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,6EAA6E;EAC7E;IACE,aAAa;EACf;AACF","sourcesContent":["/**\r\n * Estrella de favoritos de la barra superior.\r\n *\r\n * El botón reutiliza `.navbar-action-btn` (mismo alto y tipografía que\r\n * Tutoriales/Avisos); aquí solo van el estado activo y el desplegable de ámbito.\r\n */\r\n\r\n.navbar-fav {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.navbar-fav-btn.is-favorite {\r\n  color: #f5b301;\r\n}\r\n\r\n.navbar-fav-btn.is-favorite .navbar-fav-icon {\r\n  fill: #f5b301;\r\n  stroke: #f5b301;\r\n}\r\n\r\n.navbar-fav-icon {\r\n  width: 18px;\r\n  height: 18px;\r\n  flex-shrink: 0;\r\n  stroke-width: 1.7;\r\n}\r\n\r\n.navbar-fav-popover {\r\n  position: absolute;\r\n  top: calc(100% + 8px);\r\n  right: 0;\r\n  z-index: 1200;\r\n  min-width: 260px;\r\n  padding: 6px;\r\n  background: var(--bg-card, #fff);\r\n  border: 1px solid var(--border, #e2e8f0);\r\n  border-radius: 10px;\r\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.22);\r\n}\r\n\r\n.navbar-fav-head {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  padding: 8px 10px 10px;\r\n  border-bottom: 1px solid var(--border, #e2e8f0);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.navbar-fav-head-title {\r\n  font-size: 0.86rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary, #0f172a);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.navbar-fav-head-sub {\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n.navbar-fav-option {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  padding: 8px 10px;\r\n  border: none;\r\n  border-radius: 7px;\r\n  background: transparent;\r\n  color: var(--text-primary, #0f172a);\r\n  font-family: inherit;\r\n  font-size: 0.82rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n\r\n.navbar-fav-option:hover {\r\n  background: rgba(var(--accent-rgb, 59, 130, 246), 0.12);\r\n}\r\n\r\n.navbar-fav-option.is-danger {\r\n  color: #dc2626;\r\n}\r\n\r\n.navbar-fav-option.is-danger:hover {\r\n  background: rgba(220, 38, 38, 0.1);\r\n}\r\n\r\n.navbar-fav-foot {\r\n  padding: 8px 10px 4px;\r\n  margin-top: 4px;\r\n  border-top: 1px solid var(--border, #e2e8f0);\r\n  font-size: 0.7rem;\r\n  line-height: 1.35;\r\n  color: var(--text-muted, #64748b);\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  /* En pantallas estrechas el navbar ya va justo: la estrella se queda sola. */\r\n  .navbar-fav-btn .action-label {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
